"use client";

import { useRef } from "react";

import ArrowIcon from "../ArrowIcon";
import Image from "../../shared/Image";
import SnapCarousel from "../SnapCarousel";
import type { SnapCarouselHandle } from "../SnapCarousel";
import styles from "./ImageSlider.module.scss";
import type { ImageProps } from "../../shared/Image/interface";
import { Video } from "@/app/[lang]/components/shared/Video";

type ImageSliderProps = {
  images: ImageProps[]
}

const ImageSlider: React.FC<ImageSliderProps> = ( props ) => {
  const { images } = props;
  const carouselRef = useRef<SnapCarouselHandle>(null);

  if ( ! images.length ) {
    return null;
  }

  if ( images.length === 1 ) {
    return <Image
        data={ images[0] }
        className={styles.image}
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
        alt="PPC Blue Romania"
    />
  }

  return (
    <div className={ styles.wrapper }>
      <SnapCarousel ref={ carouselRef } dots>
        {images.map((image) => (
          <DisplayMedia data={ image } key={ image.id }/>
        ))}
      </SnapCarousel>

      <ArrowIcon
        color="#9f9f9f"
        direction="left"
        className={ styles.arrowPrev }
        onClick={() => carouselRef.current?.prev()}
      />
      <ArrowIcon
        color="#9f9f9f"
        direction="right"
        className={ styles.arrowNext }
        onClick={() => carouselRef.current?.next()}
      />
    </div>
  );
}

export default ImageSlider;

const DisplayMedia = ({ data }: { data: ImageProps }) => {
  const { mime } = data.attributes;

  return mime?.startsWith("video") ? (
      <div className={styles.slide}>
        <Video data={ data } />
      </div>
  ) : (
      <div className={styles.slide}>
        <Image
            data={ data }
            className={styles.image}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            alt="PPC Blue Romania"
        />
      </div>
  )
}
